<template>
  <div class="block">
    <el-timeline>
      <message
        v-for="(message, index) in getMessages"
        :key="index"
        :message="message"
        :create_at_image="message.Employeer.imageUrl"
        :create_at_name="message.CreateUser.FullName"
        @message-action="handleAction"
      />
      <LoadingMessageVue v-show="getMessages.length === 0 && loading" />
      <ErrorMessageVue v-show="getMessages.length === 0 && !loading" />
    </el-timeline>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import LoadingMessageVue from "./LoadingMessage.vue";
import ErrorMessageVue from "./ErrorMessage.vue";

export default {
  name: "MessageList",
  components: {
    LoadingMessageVue,
    ErrorMessageVue,
    Message: () => ({
      component: import(/* webpackChunkName: "Message" */ "./Message"),
      loading: LoadingMessageVue,
      error: ErrorMessageVue,
      timeout: 30000 // <=======================================
    })
  },
  computed: {
    ...mapState({ getMessages: (state) => state.message.list }),
    ...mapGetters({ loading: "message/isLoading" })
  },
  methods: {
    handleAction(message_id, command) {
      this.$emit("message-action", message_id, command);
    }
  },
  watch: {
    getMessages(val) {
      if (typeof "object" && val.length !== undefined && val.length > 0) {
        let self = this;
        setTimeout(function () {
          self.$emit("show-cards", true);
        }, 200);
      } else {
        this.$emit("show-cards", false);
      }
    }
  }
};
</script>

<style></style>
